import React from "react";
import { Sparkles } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";

const SUGGESTION_KEYS = [
  "chat.suggestion.1",
  "chat.suggestion.2",
  "chat.suggestion.3",
  "chat.suggestion.4",
  "chat.suggestion.5",
];

/**
 * EmptyState — welcome card + clickable suggestion chips shown when there
 * are no messages yet in the conversation.
 */
export default function EmptyState({ onPickSuggestion }) {
  const { t } = useLanguage();
  return (
    <div className="space-y-3">
      <div className="bg-[#050505] border border-white/[0.04] p-3 text-xs text-[#CBD5E1] leading-relaxed">
        <div className="flex items-center gap-2 mb-2">
          <Sparkles className="w-3.5 h-3.5 text-[#00E5FF]" />
          <span className="text-[10px] text-[#00E5FF] tracking-widest uppercase font-bold">{t("chat.hello")}</span>
        </div>
        {t("chat.intro_prefix")} <span className="text-white font-semibold">Intelligence DB Assistant</span>{t("chat.intro_suffix")}
      </div>
      <div className="space-y-1.5">
        {SUGGESTION_KEYS.map((key, i) => (
          <button
            key={key}
            data-testid={`chat-suggestion-${i}`}
            onClick={() => onPickSuggestion(t(key))}
            className="w-full text-left text-xs text-[#00E5FF] hover:text-white hover:bg-[#00E5FF]/10 border border-white/[0.04] hover:border-[#00E5FF]/40 px-3 py-2 transition-colors"
          >
            → {t(key)}
          </button>
        ))}
      </div>
    </div>
  );
}
